/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SubscribeResponseType = typeof SubscribeResponseType[keyof typeof SubscribeResponseType];


export const SubscribeResponseType = {
  payment: 'payment',
  setup: 'setup',
} as const;
